import 'slick/slick.min.js';
import 'acf-maps.js';
import 'glightbox/glightbox.js';

(function($) {
	/* Toggle nav */

	$(document).on('click', '.-js-navModal-toggle', function() {
		$(this).toggleClass('-open');
		$('body').toggleClass('-navModal-open');
		$('.-js-navModal').toggleClass('-collapsed');
		var isOpen = $(this).hasClass('-open');
		$(this).attr('aria-label', isOpen ? 'Sluit menu' : 'Open menu');
	});

	/* Slick carousel */
	var $carousel = $('.js-carousel');

	var carouselSettings = {
		slidesToShow: 1,
		sldesToScroll: 1,
		arrows: true,
		waitForAnimate: true,
		swipe: true,
		touchMove: true,
		accessibility: true,
		nextArrow: '<button class="carousel__arrow -next" aria-label="Verder scrollen in carousel"></button>',
		prevArrow: '<button class="carousel__arrow -previous" aria-label="Terug scrollen in carousel"></button>',
		infinite: true,
		mobileFirst: true,
		centerMode: true,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 3,
					centerMode: false,
				},
			},
			{
				breakpoint: 830,
				settings: {
					slidesToShow: 4,
					centerMode: false,
				},
			},
		],
	};

	// Logo carousel
	var $logoCarousel = $('.js-carousel-logo');

	var logoCarouselSettings = {
		slidesToShow: 1,
		sldesToScroll: 1,
		arrows: true,
		waitForAnimate: true,
		swipe: true,
		touchMove: true,
		accessibility: false,
		nextArrow: '<button class="carousel__arrow -next" aria-label="Verder scrollen in carousel"></button>',
		prevArrow: '<button class="carousel__arrow -previous" aria-label="Terug scrollen in carousel"></button>',
		infinite: true,
		mobileFirst: true,
		centerMode: true,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 3,
					centerMode: false,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 4,
					centerMode: false,
				},
			},
			{
				breakpoint: 830,
				settings: {
					slidesToShow: 5,
					centerMode: false,
				},
			},
		],
	};

	// Init carousels
	$carousel.slick(carouselSettings);
	$logoCarousel.slick(logoCarouselSettings);

	// Header scroll class
	$(window).on('load scroll', function() {
		var scrollTop = $(this).scrollTop();
		var header = $('.js-header');
		if (scrollTop > 100) {
			header.addClass('-scrolling');
		} else {
			header.removeClass('-scrolling');
		}
	});

	// Mobile menu
	$(document).on('click', '.js-mobile-nav .menu-item.has-megamenu > a, .js-mobile-nav .menu-item.menu-item-has-children > a', function(e) {
		e.preventDefault();
		$(this)
			.parent()
			.toggleClass('-active');
	});

	// Help button
	$(document).on('click', '.js-help-toggle', function() {
		$('.js-help').toggleClass('-active');
	});

	// Fancybox
	// LIGHTBOX
	var lightbox = GLightbox({
		selector: '.js-lightbox',
		zoomable: false,
	});

	// Help button
	$(document).on('click', '.js-faq-toggle', function() {
		$('.js-faq.-active').removeClass('-active');
		$(this)
			.parent()
			.toggleClass('-active');
	});

	//// SMOOTH SCROLL ANCHOR LINKS /////

	// Select all links with hashes
	$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.click(function(event) {
			// On-page links
			if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
				// Figure out element to scroll to
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				// Does a scroll target exist?
				if (target.length) {
					// Only prevent default if animation is actually gonna happen
					var $offset = $('.js-header').outerHeight() + 20;
					event.preventDefault();
					$('html, body').animate(
						{
							scrollTop: target.offset().top - $offset,
						},
						500
					);
				}
			}
		});
})(jQuery);
